/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'breakpoints'
  ],
  function pipNeedMoreBopisProducts(
      $,
      Mustache,
      pipModel,
      breakpoints
  ) {
      var SMALL = 'Small';

      var view = {
        selectors: {
          needMoreProductsTooltipWrapperId: '#need-more-products-tooltip',
          needMoreProductTooltipOpenerId: '#needMoreProductsTooltipOpener',
          needMoreQuantityProductsTooltipWrapperId: '#need-more-quantity-products-tooltip',
          needMoreAvailableQuantitySelectorId: '#available-quantity',
          inStoreAssemblyId: '#buybox__in-store-assembly',
          buyboxQuantityContainerId: '.buybox__quantity-flex',
          buyboxQuantityInputId: '#buybox__quantity__input',
          buyboxWrapper: '.buybox__wrapper'
        },
        classes: {
          needMoreProductsTooltipArrow: 'Tooltip__arrow--need-more-products',
          needMoreProductsArrowContainer: 'Tooltip__arrow-container--need-more-products',
          needMoreProductsTooltip: 'Tooltip--need-more-products'
        },
        templates: {
          needMoreProductsCommonTemplate: $('#buybelt__need_more_products').html(),
          needMoreQuantityTrigger: '<span id=\'need-more-quantity-tooltip-trigger\'></span>',
          needMoreProductsTooltip: '\
              <div id="need-more-products-tooltip">\
                  {{>needMoreProductsCommonTemplate}}\
              </div>',
          needMoreQuantityTooltip: '\
              <div id="need-more-quantity-header">\
                  <div class="alert-inline--warning u__block Tooltip-header m-bottom-standard">\
                      <span>Your store only has <span id="available-quantity"></span> in stock.</span>\
                  </div>\
              <div id="need-more-quantity-products-tooltip">{{>needMoreProductsCommonTemplate}}</div>',
        },
        render: {
          needMoreQuantityTooltipContent: function renderNeedMoreQuantityTooltipContent() {
            return Mustache.render(view.templates.needMoreQuantityTooltip, pipModel, view.templates);
          },
          needMoreProductsTooltipContent: function renderNeedMoreProductsTooltipContent() {
            return Mustache.render(view.templates.needMoreProductsTooltip, pipModel, view.templates);
          },
          needMoreQuantityTooltipTrigger: function renderNeedMoreQuantityTooltipTrigger() {
            return Mustache.render(view.templates.needMoreQuantityTrigger);
          }
        }
      };

      function getRootTooltipContainer(tooltipWrapperId) {
          return $('div[id*=tooltip]').has(tooltipWrapperId);
      }

      function createNeedMoreQuantityTooltip() {
          $(view.selectors.buyboxQuantityInputId)
          .append(view.render.needMoreQuantityTooltipTrigger())
              .tooltip({
                  position: 'top',
                  width: 'medium',
                  content: view.render.needMoreQuantityTooltipContent(),
                  type: 'click',
                  closeButton: true,
                  closeOnClick: true,
                  onOpen: function ($tooltip, complete) {
                      var availableQuantity = pipModel.inventory.store.quantity;

                      if (Number($(view.selectors.buyboxQuantityInputId).val()) > availableQuantity) {
                          getRootTooltipContainer(view.selectors.needMoreQuantityProductsTooltipWrapperId)
                              .children()
                              .addClass(view.classes.needMoreProductsTooltip);
                          getRootTooltipContainer(view.selectors.needMoreQuantityProductsTooltipWrapperId)
                              .addClass(view.classes.needMoreProductsTooltip)
                              .find(view.selectors.needMoreAvailableQuantitySelectorId)
                              .text(availableQuantity);
                          customizeMobileVersionTooltip(view.selectors.needMoreQuantityProductsTooltipWrapperId);
                          fixTooltipArrowPosition();
                          complete()
                      }
                  },
                  onClose: function () {
                      if (breakpoints.isActiveBreakpointEqualToOrSmallerThan(SMALL)) {
                          getRootTooltipContainer(view.selectors.needMoreQuantityProductsTooltipWrapperId).hide();
                          $(view.selectors.inStoreAssemblyId).show();
                      }
                  }
              });
      }

      function createNeedMoreProductsTooltip() {
          $(view.selectors.needMoreProductTooltipOpenerId)
              .tooltip({
                  position: 'bottom',
                  width: 'medium',
                  bestPosition: false,
                  content: view.render.needMoreProductsTooltipContent(),
                  type: 'click',
                  closeButton: true,
                  closeOnClick: true,
                  onOpen: function ($tooltip, complete) {
                      getRootTooltipContainer(view.selectors.needMoreProductsTooltipWrapperId)
                          .children()
                          .addClass(view.classes.needMoreProductsTooltip);
                      getRootTooltipContainer(view.selectors.needMoreProductsTooltipWrapperId)
                          .addClass(view.classes.needMoreProductsTooltip);

                      customizeMobileVersionTooltip(view.selectors.needMoreProductsTooltipWrapperId);
                      fixTooltipArrowPosition();
                      complete();
                  },
                  onClose: function () {
                      if (breakpoints.isActiveBreakpointEqualToOrSmallerThan(SMALL)) {
                          getRootTooltipContainer(view.selectors.needMoreProductsTooltipWrapperId).hide();
                          $(view.selectors.inStoreAssemblyId).show();
                      }
                  }
              });
      }

      function customizeMobileVersionTooltip(tooltipWrapperId) {
         var rootTooltipContainer = getRootTooltipContainer(tooltipWrapperId);
         rootTooltipContainer.show();

          if (breakpoints.isActiveBreakpointEqualToOrSmallerThan(SMALL)) {
             rootTooltipContainer
                 .children()
                 .first()
                 .removeClass(view.classes.needMoreProductsTooltip);
              $(view.selectors.buyboxWrapper).after(rootTooltipContainer);

              if (isInStoreAssemblyWrapped()) {
                  $(view.selectors.inStoreAssemblyId).hide();
              }
          }
      }

      function isInStoreAssemblyWrapped() {
          return breakpoints.isActiveBreakpointEqualToOrSmallerThan(SMALL)
            && ($(view.selectors.inStoreAssemblyId).width() === $(view.selectors.buyboxQuantityContainerId).width());
      }

      function fixTooltipArrowPosition() {
          setTimeout(function () {
              var rootTooltipContainer = getRootTooltipContainer(view.selectors.needMoreProductsTooltipWrapperId);

              getRootTooltipContainer(view.selectors.needMoreQuantityProductsTooltipWrapperId)
                  .children()
                  .first()
                  .removeClass(view.classes.needMoreProductsTooltip);
              rootTooltipContainer.addClass(view.classes.needMoreProductsArrowContainer);
              rootTooltipContainer
                  .children()
                  .first()
                  .addClass(view.classes.needMoreProductsTooltipArrow);
          }, 0);
      }

      return {
          init: function init() {
            setTimeout(function () {
              createNeedMoreProductsTooltip();
              createNeedMoreQuantityTooltip();
            }, 0);
          }
      };
  });

}.call(window));